import React from 'react'
import ReactDOM from 'react-dom'
import { store, history } from './store'
import Root from './containers/Root'
import { authLoginSuccess } from './actions/auth'

const target = document.getElementById('root')

const root = (
  <Root store={store} history={history} />
)

const token = localStorage.getItem('token')
if (token !== null) {
  store.dispatch(authLoginSuccess(token))
}

// Neutralize Windows display scaling / browser zoom so the app always
// renders at an effective 100%. Gated to Windows because on macOS/mobile a
// devicePixelRatio > 1 means a genuinely high-DPI screen, not zoom, and
// compensating there would shrink the UI to half size or worse.
function applyForcedZoom () {
  const isWindows = navigator.userAgent.includes('Windows')
  const dpr = window.devicePixelRatio || 1
  document.documentElement.style.zoom =
    (isWindows && dpr > 1) ? String(1 / dpr) : ''
}
applyForcedZoom()
window.addEventListener('resize', applyForcedZoom)

ReactDOM.render(root, target)
